import React from 'react';
import { Box, ButtonBase } from '@mui/material';
import { InterventionLadderStepModel } from '../../../api-service/clients';
import { formatNumber } from '../../../utilities';
import { InternalExternalSplit } from './intervention-cost';
import { ShowActivitiesLink } from './intervention-activities-dialog';

export function formatSuppliers(count: number) {
  return count === 1 ? 'leverandør' : 'leverandører';
}

export function formatActivitiesWithUnknownSupplier(count: number) {
  return `${formatNumber(count)} ${count === 1 ? 'aktivitet' : 'aktiviteter'} uden kendt leverandør`;
}

interface InterventionLadderStepSuppliersProps {
  step: InterventionLadderStepModel;
  isSelected: boolean;
  onSelect: () => void;
  onShowActivities: () => void;
}

export function InterventionLadderStepSuppliers({ step, isSelected, onSelect, onShowActivities }: InterventionLadderStepSuppliersProps) {
  const { suppliers } = step;
  return (
    <ButtonBase
      component="div"
      onClick={onSelect}
      aria-pressed={isSelected}
      aria-label={`Leverandører på trin ${step.step}: ${formatNumber(suppliers.total)}`}
      sx={{
        display: 'block',
        textAlign: 'left',
        font: 'inherit',
        borderRadius: '10px',
        px: 1.75,
        py: 1.5,
        bgcolor: '#f3f8fb',
        border: '1px solid rgba(24, 76, 97, 0.12)',
        color: '#16323d',
        outline: isSelected ? '3px solid #1f4d61' : 'none',
        outlineOffset: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
        <Box sx={{ fontSize: '1.25rem', fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{formatNumber(suppliers.total)}</Box>
        <Box sx={{ fontSize: '0.6875rem', color: 'text.secondary' }}>{formatSuppliers(suppliers.total)}</Box>
      </Box>
      <InternalExternalSplit
        internal={suppliers.internal}
        external={suppliers.external}
        format={formatNumber}
        label={`${formatNumber(suppliers.internal)} interne, ${formatNumber(suppliers.external)} eksterne`}
      />
      {suppliers.activitiesWithUnknownSupplier > 0 && (
        <ShowActivitiesLink text={formatActivitiesWithUnknownSupplier(suppliers.activitiesWithUnknownSupplier)} onShow={onShowActivities} />
      )}
    </ButtonBase>
  );
}
